import service from './service';
import { useQuery } from 'react-query';
import { Evaluation, EvaluationResponseInterface } from '../interfaces/EvaluationInterface';

export const getEvaluate = async (id: string) => {
  let response = await service.get(`/company/evaluating/?travel_id=${id}`);
  return response;
};

export const sendReview = async (body: object) => {
  let data = await service.put('/company/evaluating', body);
  return data;
};

export const getEvaluateList = async () => {
  const pending = await service.get('/company/evaluating/listing?status=pending');
  const evaluated = await service.get('/company/evaluating/listing?status=evaluated');

  return {
    data: [
      ...pending.data,
      ...evaluated.data.map((item) => {
        return {
          ...item,
          votes: item.rating,
        };
      }),
    ],
  };
};

export const getAttributesList = async () => {
  let data = await service.get('/company/evaluating/listing-attributes');
  return data;
};

export const getSingleReviewPending = async () => {
  const data = await service.get('/company/evaluating/one-pending');
  return data;
};

export const getPendingReviewList = async () => {
  const data = await service.get('/company/evaluating/listing-pending');
  return data;
};

export const getSelectedEvaluated = async (uuid: string) => {
  const { data } = await service.get(`/company/evaluating/travel/${uuid}`);
  return data;
};

const getEvaluation = (): Promise<EvaluationResponseInterface['data']> => {
  const uri = '/company/evaluating/listing?status=pending';

  return service.get(uri).then((response) => response.data);
};

export const getEvaluationList = () =>
  useQuery<Evaluation[], Error>('getEvaluation', () => getEvaluation());

const getPendingCount = () => {
  const uri = '/company/evaluating/pending-count';
  return service.get(uri).then((res) => res.data);
};

export const useGetPendingCount = () => {
  const results = useQuery('getPendingCount', () => getPendingCount());
  return results;
};
